import { IMAGE_RATIOS, normalizeImageRatio } from "@/lib/api";

export default function ImageRatioPicker({ value, onChange, defaultRatio = "4:3", testid, compact = false }) {
  const selected = normalizeImageRatio(value, defaultRatio);

  return (
    <div className={compact ? "mt-2" : "mt-3"} data-testid={testid}>
      {!compact && <p className="text-[10px] font-bold uppercase tracking-widest text-slate-500 mb-1.5">Rasio Tampilan</p>}
      <div className="inline-flex rounded-md border border-slate-300 bg-slate-50 p-0.5" role="group" aria-label="Pilih rasio gambar">
        {IMAGE_RATIOS.map((ratio) => (
          <button
            key={ratio.value}
            type="button"
            onClick={() => onChange(ratio.value)}
            data-testid={testid ? `${testid}-${ratio.value.replace(":", "-")}` : undefined}
            aria-pressed={selected === ratio.value}
            className={`${compact ? "px-2 py-1 text-[10px]" : "px-3 py-1.5 text-xs"} rounded font-bold transition-colors ${selected === ratio.value ? "bg-[#0B1F3A] text-white shadow-sm" : "text-slate-500 hover:text-[#0B1F3A]"}`}
          >
            {ratio.label}
          </button>
        ))}
      </div>
    </div>
  );
}
